import axios from 'axios';

import { App } from '../App';
import { RestoreableModel, ResourceFactory, Auth, Query, Resource } from '../services/';
import { Stationcategory } from '.';
import { IMapElement } from '../modules';

class Station extends RestoreableModel {
  public name: string = '';
  public description: string = '';
  public latitude: number;
  public longitude: number;
  public depth: number;

  public samples_count: number;
  public stationcategories_count: number;
  public stationcategories: Stationcategory[] = [];
}

// Declare additional methods for StationFactory.
interface IStationFactory {
  getMap?: (auth: Auth, query: Query, bounds: L.LatLngBounds, zoom: number) => Promise<IMapElement[]>;
}

const StationFactory: IStationFactory & Resource<Station> = ResourceFactory.create<Station>(Station, 'station');

// Add additional methods:
StationFactory.getMap = (auth: Auth, query: Query, bounds: L.LatLngBounds, zoom: number): Promise<IMapElement[]> => {
  return new Promise((resolve, reject) => {
    // Prepare viewport bounds for API:
    const lng1 = bounds.getNorthWest().lng;
    const lat1 = bounds.getNorthWest().lat;
    const lng2 = bounds.getSouthEast().lng;
    const lat2 = bounds.getSouthEast().lat;

    let queryUrl = query.toUrl();
    if(queryUrl) queryUrl = '&' + queryUrl;
    axios.get(
      `${App.apiURL}stations/map/${lng1}/${lat1}/${lng2}/${lat2}/${zoom}?api_token=${auth.token}${queryUrl}`)
    .then(response => {
      const data: IMapElement[] = response.data;
      resolve(data);
    })
    .catch(error => {
      reject(error);
    })
  });
}

export { Station, StationFactory };